$(document).ready(function () {
    const hamburger = $('.hamburger'),
        dealerHamburger = $('.dealer-hamburger'),
        menu = $('.dealer-header');

    let inAction = false;

    dealerHamburger.click(function () {
        if (inAction) return;
        inAction = true;

        if (hamburger.hasClass('is-active')) hamburger.click();

        $(this).toggleClass('is-active');
        $('body').toggleClass('no-scroll menued');
        menu.toggleClass('active');

        setTimeout(() => inAction = false, 550);
    });

});